import { BrowserRouter, Route, Switch } from "react-router-dom";
import routes from "configs/routes";
import React from "react";
import { AuthProvider } from "views/Authentication/AuthContext";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

import { FGVTheme } from "theme/colors";
import {
  getCollapsibleRoutes,
  getCollapsibleSubRoutes,
  getMainRoutes,
} from "utils";
import { SidebarProvider } from "components/Sidebar/SidebarContext";
import withLayout from "./configs/withLayout";
import DefaultLayout from "./layouts/DefaultLayout";
import Error from "./views/Error/Error";
import FGVFontName from "theme/font";

const theme = createMuiTheme({
  ...FGVTheme,
  typography: {
    ...(FGVTheme.typography || {}),
    ...FGVFontName,
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <SidebarProvider>
          <BrowserRouter>
            <Switch>
              {/*First route map to populate normal routes*/}
              {getMainRoutes(routes)}
              {/*This map is done to populate collapsible routes in sidebar*/}
              {routes.map((route, index) =>
                // Only populate route if it's collapsible
                getCollapsibleRoutes(index, route)
              )}
              {routes.map((route, index) =>
                // Only populate route if it's a subRoute of collapsible route
                getCollapsibleSubRoutes(index, route)
              )}
              <Route
                alakazam={true}
                render={(props) => {
                  let newProps = { ...props, ...{ redirect: true } };
                  return withLayout(DefaultLayout, Error)(newProps);
                }}
              />
            </Switch>
          </BrowserRouter>
        </SidebarProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
